import React from 'react'
import PropTypes from 'prop-types'
import SummaryTileContainer from '../containers/summary_tile_container'
import { VIEW_MODES } from '../constants'

// Web-only stack of collapsed summary tiles, shown above the leaderboards.
const SummariesList = ({ enabledKeys = [], viewMode }) => {
  if (enabledKeys.length === 0) { return null }

  return (
    <ol className="lbv2__without-favorites lbv2__summaries-list">
      {enabledKeys.map((summaryKey) => (
        <SummaryTileContainer key={summaryKey} summaryKey={summaryKey} viewMode={viewMode} />
      ))}
    </ol>
  )
}

SummariesList.propTypes = {
  enabledKeys: PropTypes.array,
  viewMode: PropTypes.oneOf(Object.values(VIEW_MODES)),
}

export default SummariesList
